import React from 'react';
import {BaseMixin, ElementaryMixin, ColorSchemaMixin, ContentMixin, NestingLevelMixin} from '../common/common.js';

import './label.less';

export const Label = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    ColorSchemaMixin,
    ContentMixin,
    NestingLevelMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Label',
    nestingLevel: 'inline',
    classNames: {
      main: 'uu5-bricks-label label'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    var mainAttrs = this.buildMainAttrs();
    !this.getColorSchema() && (mainAttrs.className += ' label-default');

    return (
      this.getNestingLevel()
        ? (
          <span {...mainAttrs}>
            {this.getChildren()}
            {this.getDisabledCover()}
          </span>
        ) : null
    );
  }
  //@@viewOff:render
});

export default Label;



// WEBPACK FOOTER //
// ./bricks/label.js